import type { Nullable } from "models-webgl2";
import { Webgl2dRenderer } from "../../../webgl2d-renderer";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";
import { MeasurementComponent } from "../measurements-component";
import { MeasurementSelectionComponent } from "./measurement-selection-component";

export class MeasurementEndControlComponent extends Webgl2Component {
  private get _selectedComponent(): Nullable<MeasurementComponent> {
    const component = this._renderer.selectedComponent;
    return component instanceof MeasurementComponent ? component : null;
  }

  constructor(
    private readonly _renderer: Webgl2dRenderer,
    private readonly _measurementSelectionComponent: MeasurementSelectionComponent,
  ) {
    super();
  }

  public onMouseDown(e: MouseEvent | TouchEvent) {
    if (!this._selectedComponent) return;

    const mouseDownPosition = this._renderer.camera.getGlobalMousePixelPosition(e);
    this._selectedComponent?.changeEndPosition(mouseDownPosition);
    this._renderer.render();
  }

  public onMouseMove(e: MouseEvent | TouchEvent) {
    const mouseDownPosition = this._renderer.camera.getGlobalMousePixelPosition(e);
    this._selectedComponent?.changeEndPosition(mouseDownPosition);
    this._renderer.render();
  }

  public getRenderData() {
    if (!this._selectedComponent) return;

    this.transform.copy(this._selectedComponent.endCircle.transform);

    const material = Webgl2.materials.selectionControl;
    material.setUniforms({
      u_size: this.transform.size.getAbs().getArray(),
    });
    return { material };
  }
}

export default MeasurementEndControlComponent;
